module.exports = __webpack_public_path__ + "components/country-flag/static/sc-256f25a246d4de52988f059f6ffdcd57.svg";